<template>
    <div :class="['d-flex', 'search-container', 'w-100']">
        <div class="search-container-form">
            <fieldset class="filters-wrapper">
                <Multiselect v-for="(data, i) of localeMultiselectArray" v-model="data.Vmodel" :options="data.options" :mode="data.mode"
                    :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                    :hideSelected="true" @select="(value, option) => allowNextMultiselect(value, option, i)" @deselect="() => blockNextMultiselects(i)"
                    @clear="() => blockNextMultiselects(i)" :locale="data.locale" :required="true"
                    class="extra-light-text light-blue-color" :id="data.sendName" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
            </fieldset>
        </div>
    </div>
</template>
<script>
import Multiselect from '@vueform/multiselect'
import axios from 'axios';
import { isProxy, toRaw } from 'vue';

export default {
    data(){
        return {
            localeMultiselectArray: [],
        }
    },
    components: {
        Multiselect,
    },
    props: {
        multiselectArray: {
            type: Array,
            default: [],
        }
    },
    mounted(){
        this.getLocaleMultiselectArray();
    },
    methods: {
        getMultiselectOptions(getterEndpoint, multiselectObj){
            axios.get(getterEndpoint).then((response) => {
                let tempArray = [];
                for(let city of response.data){
                    tempArray.push({
                        value: city[multiselectObj.valueName],
                        label: {
                            ge: city[multiselectObj.georgianLabel],
                            en: city[multiselectObj.englishLabel],
                        },
                    });
                }
                multiselectObj.options = tempArray;
            })
        },
        getLocaleMultiselectArray(){
            this.localeMultiselectArray = this.multiselectArray;
            this.getMultiselectOptions(this.localeMultiselectArray[0].getterEndpoint, this.localeMultiselectArray[0]);
        },
        allowNextMultiselect(value, option, index){
            if(index < this.localeMultiselectArray.length - 1){
                if(this.localeMultiselectArray[index].dependancyArray.length > 0){
                    for(let dependancyObj of this.localeMultiselectArray[index].dependancyArray){
                        this.localeMultiselectArray[index + 1].dependancyArray.push(dependancyObj);
                    }
                }
                this.localeMultiselectArray[index + 1].dependancyArray.push({
                    value: option.value,
                    label: option.label,
                    sendName: this.localeMultiselectArray[index].sendName,
                });
                this.localeMultiselectArray[index + 1].previousMultiselectId = option.value;
                this.localeMultiselectArray[index + 1].isDisabled = false;
                this.localeMultiselectArray[index + 1].Vmodel = null;
                if(this.localeMultiselectArray[index + 1].sendName != null){
                    
                    this.$emit("finalResult", {value: null, sendName: this.localeMultiselectArray[index + 1].sendName});
                }
                this.getMultiselectOptions(`${this.localeMultiselectArray[index + 1].getterEndpoint}/${this.localeMultiselectArray[index + 1].previousMultiselectId}`, this.localeMultiselectArray[index + 1]);
            }
            if(this.localeMultiselectArray[index].sendName != null){
                this.$emit("finalResult", {value: option.value, sendName: this.localeMultiselectArray[index].sendName});
            }
            if(index < this.localeMultiselectArray.length - 2){
                this.blockNextMultiselects(index + 1);
            }
        },
        blockNextMultiselects(index){
            if(this.localeMultiselectArray[index].sendName != null){
                this.$emit("finalResult", {value: null, sendName: this.localeMultiselectArray[index].sendName});
            }
            
            if(index >= this.localeMultiselectArray.length - 1){
                return;
            }
            
            this.localeMultiselectArray[index + 1].Vmodel = null;
            // this.localeMultiselectArray[index + 1].options = [];
            this.localeMultiselectArray[index + 1].dependancyArray = [];
            this.localeMultiselectArray[index + 1].isDisabled = true;
            this.localeMultiselectArray[index + 1].previousMultiselectId = null;
            this.localeMultiselectArray[index + 1].options = [];
            this.blockNextMultiselects(index + 1);
        },
        isValid(value){
            if(value == "" || value == null || value == undefined){
                return false;
            }
            return true;
        },
    }
}
</script>
<style scoped>
.search-container{
    justify-content: space-between;
    align-items: center;
    background-color: var(--secondary-background-color);
    border-radius: 10px;
    column-gap: 3em;
}
.search-container-form{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1em;
}
.search-container.mode-1 .primary-input{
    max-width: 520px;
}
.search-container-form .filters-wrapper{
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: start;
    gap: 15px;
}
.search-container-form .filters-wrapper .multiselect{
    --ms-placeholder-color: var(--light-blue);
    --ms-tag-bg: var(--light-blue);
    --ms-option-bg-selected: var(--light-blue);
    --ms-option-bg-selected-pointed: var(--light-blue);
    flex: 1;
    margin: 0;
}
.search-container-form > h6{
    font-weight: 600;
}
@media screen and (max-width: 1800px) {
    .search-container{
        justify-content: space-between;
        align-items: flex-start;
    }
    .search-container.mode-1 .primary-input{
        max-width: 400px;
    }
    .search-container:not(.mode-1) .search-container-form{
        flex-direction: column;
        justify-content: start;
        align-items: start;
    }
    .search-container-form > h6, .excel-export-button{
        margin: 0;
    }
    .search-container:not(.mode-1) .search-container-form .filters-wrapper{
        flex-wrap: wrap;
        justify-content: start;
    }
    .search-container-form .filters-wrapper .multiselect{
        min-width: 180px;
    }
}
@media screen and (max-width: 1560px) {
    .search-container.mode-1 .primary-input{
        max-width: 300px;
    }
}
</style>